import { Trans } from "@lingui/macro";
import { UiBox, UiIconStandard, UiLink, UiTypography } from "@smp/ui";
import { useNavigate } from "react-router-dom";

import { useStyles } from "./notification_set_password.css";

export const NotificationSetPassword = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const navigate = useNavigate();

  const classes = useStyles();

  const handleClick = () => {
    onClose();
    navigate("/settings/password");
  };

  return (
    <UiBox
      display="flex"
      className={classes.box_notification_body}
      flexDirection="row"
      paddingBottom={2}
      paddingLeft={2}
      paddingRight={2}
      paddingTop={4}
    >
      <UiBox flexGrow={0} width={50}>
        <UiIconStandard variant="warning" />
      </UiBox>
      <UiBox flexGrow={1} paddingLeft={2}>
        <UiTypography>
          <Trans>
            Set your password in <UiLink onClick={handleClick}>Settings</UiLink>{" "}
            and use it to log in to SMMplanner.
          </Trans>
        </UiTypography>
      </UiBox>
    </UiBox>
  );
};
